import { render, staticRenderFns } from "./unsubscribe-data-setting.vue?vue&type=template&id=6928b17c"
import script from "./unsubscribe-data-setting.vue?vue&type=script&lang=js"
export * from "./unsubscribe-data-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports